export const defaultConfigForDesignAndShape = {
  SLTR: {
    // Solitaire category
    BL: {
      //   // Bali
      //   CR: "CONFIG-1CT-ND-CR-SLTR-BL-14K-W-S7.25",
      //   RB: "CONFIG-1CT-ND-RB-SLTR-BL-14K-W-S7.25",
      //   PE: "CONFIG-1CT-ND-PE-SLTR-BL-14K-W-S7.25",
      //   OV: "CONFIG-1CT-ND-OV-SLTR-BL-14K-W-S7.25",
      //   MQ: "CONFIG-1CT-ND-MQ-SLTR-BL-14K-W-S7.25",
    },
    SO: {
      // Solstice
      RB: "CONFIG-1CT-ND-RB-SLTR-SO-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-SO-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-SO-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-SO-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-SO-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-SLTR-SO-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-SLTR-SO-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-SO-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-SO-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-SLTR-SO-14K-W-S7.25",
    },
    MRS: {
      // Marseille
      MQ: "CONFIG-0.75CT-ND-MQ-SLTR-MRS-14K-W-S7.25",
      CR: "CONFIG-1.25CT-ND-CR-SLTR-MRS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-MRS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-MRS-14K-W-S7.25",
      RB: "CONFIG-1CT-ND-RB-SLTR-MRS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-MRS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-MRS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-MRS-14K-W-S7.25",
    },
    CTD: {
      // Cathedral
      RB: "CONFIG-1CT-ND-RB-SLTR-CTD-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-CTD-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-CTD-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-CTD-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-CTD-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-SLTR-CTD-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-SLTR-CTD-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-CTD-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-CTD-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-SLTR-CTD-14K-W-S7.25",
    },
    IVY: {
      // Ivy
      // RB: "CONFIG-1CT-ND-RB-SLTR-IVY-14K-W-S7.25",
    },
    SG: {
      // Sage
      RB: "CONFIG-1CT-ND-RB-SLTR-SG-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-SG-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-SG-14K-W-S7.25",
    },
    BS: {
      // Basket Set
      RB: "CONFIG-1CT-ND-RB-SLTR-BS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-BS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-BS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-BS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-BS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-BS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-BS-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-SLTR-BS-14K-W-S7.25",
    },
    EL: {
      // The Elan
      RB: "CONFIG-1.5CT-ND-RB-SLTR-EL-14K-W-S7.25",
    },
    TW: {
      // Twisted
      RB: "CONFIG-1CT-ND-RB-SLTR-TW-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-TW-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-TW-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-TW-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-TW-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-SLTR-TW-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-TW-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-TW-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-SLTR-TW-14K-W-S7.25",
    },
    EW: {
      // East West
      RA: "CONFIG-1CT-ND-RA-SLTR-EW-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-EW-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-EW-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-SLTR-EW-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-EW-14K-W-S7.25",
      TL: "CONFIG-1CT-ND-TL-SLTR-EW-14K-W-S7.25",
    },
    AR: {
      // Arezzo
      RB: "CONFIG-1CT-ND-RB-SLTR-AR-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-AR-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-AR-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-AR-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-AR-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-AR-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-AR-14K-W-S7.25",
    },
    BSB: {
      // Basket Set Bold
      RB: "CONFIG-1CT-ND-RB-SLTR-BSB-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-SLTR-BSB-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-SLTR-BSB-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-SLTR-BSB-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-SLTR-BSB-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-SLTR-BSB-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-SLTR-BSB-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-SLTR-BSB-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-SLTR-BSB-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-SLTR-BSB-14K-W-S7.25",
    },
    MGLR: {
      // Morning Glory
      RB: "CONFIG-1CT-ND-RB-SLTR-MGLR-14K-W-S7",
      PR: "CONFIG-1CT-ND-PR-SLTR-MGLR-14K-W-S7",
      CR: "CONFIG-1CT-ND-CR-SLTR-MGLR-14K-W-S7",
      AS: "CONFIG-1CT-ND-AS-SLTR-MGLR-14K-W-S7",
    },
  },
  AC: {
    // AC category
    HV: {
      // Haven
      RB: "CONFIG-1CT-ND-RB-AC-HV-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-HV-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-HV-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-HV-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-HV-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-HV-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-AC-HV-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-HV-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-HV-14K-W-S7.25",
    },
    FL: {
      // Fleur
      RB: "CONFIG-1CT-ND-RB-AC-FL-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-FL-14K-W-S7.25",
    },
    CS: {
      // Cinderella
      RB: "CONFIG-1CT-ND-RB-AC-CS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-CS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-CS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-CS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-CS-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-CS-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-AC-CS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-CS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-EM-AC-CS-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-CS-14K-W-S7.25",
    },
    SE: {
      // Seine
      RB: "CONFIG-1CT-ND-RB-AC-SE-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-SE-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-SE-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-SE-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-SE-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-SE-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-SE-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-SE-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-SE-14K-W-S7.25",
    },
    CMW: {
      // Color my World
      RB: "CONFIG-1CT-ND-RB-AC-CMW-14K-W-S7.25",
    },
    KS: {
      // Kite Set
      RB: "CONFIG-1CT-ND-RB-AC-KS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-KS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-KS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-KS-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-KS-14K-W-S7.25",
    },
    IR: {
      // Irene
      RB: "CONFIG-1CT-ND-RB-AC-IR-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-IR-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-IR-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-IR-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-IR-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-AC-IR-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-IR-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-IR-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-IR-14K-W-S7.25",
    },
    PET: {
      // Petite
      RB: "CONFIG-1CT-ND-RB-AC-PET-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-PET-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-PET-14K-W-S7.25",
    },
    ANG: {
      // Angelix
      CR: "CONFIG-1CT-ND-CR-AC-ANG-14K-W-S7.25",
      RB: "CONFIG-1CT-ND-RB-AC-ANG-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-ANG-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-ANG-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-ANG-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-ANG-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-ANG-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-AC-ANG-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-ANG-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-ANG-14K-W-S7.25",
    },
    BL: {
      //   // Bali
      //   RB: "CONFIG-1CT-ND-RB-AC-BL-14K-W-S7.25",
      //   PE: "CONFIG-1CT-ND-PE-AC-BL-14K-W-S7.25",
      //   OV: "CONFIG-1CT-ND-OV-AC-BL-14K-W-S7.25",
      //   MQ: "CONFIG-1CT-ND-MQ-AC-BL-14K-W-S7.25",
    },
    IL: {
      // Infinite
      RB: "CONFIG-1CT-ND-RB-AC-IL-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-IL-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-IL-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-IL-14K-W-S7.25",
    },
    SG: {
      // Sage
      RB: "CONFIG-1CT-ND-RB-AC-SG-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-SG-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-SG-14K-W-S7.25",
    },
    BS: {
      // Basket Set
      RB: "CONFIG-1CT-ND-RB-AC-BS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-BS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-BS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-BS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-BS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-BS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-BS-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-BS-14K-W-S7.25",
    },
    TW: {
      // Twisted
      RB: "CONFIG-1CT-ND-RB-AC-TW-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-TW-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-TW-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-TW-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-TW-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-TW-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-TW-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-TW-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-TW-14K-W-S7.25",
    },
    EW: {
      // East West
      RA: "CONFIG-1CT-ND-RA-AC-EW-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-EW-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-EW-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-EW-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-EW-14K-W-S7.25",
      TL: "CONFIG-1.50CT-TL-AC-EW-14K-W-S7.25",
    },
    AR: {
      // Arezzo
      RB: "CONFIG-1CT-ND-RB-AC-AR-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-AR-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-AR-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-AR-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-AR-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-AR-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-AR-14K-W-S7.25",
    },
    GW: {
      // Gwyneth
      RB: "CONFIG-1CT-ND-RB-AC-GW-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-AC-GW-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-AC-GW-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-GW-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-GW-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-AC-GW-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-AC-GW-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-GW-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-GW-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-AC-GW-14K-W-S7.25",
    },
    VL: {
      // Valencia
      RB: "CONFIG-1CT-ND-RB-AC-VL-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-AC-VL-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-AC-VL-14K-W-S7.25",
    },
    T2R: {
      // Tapered 2-Row
      RB: "CONFIG-1CT-ND-RB-AC-T2R-14K-W-S7.25",
      PC: "CONFIG-1CT-ND-PR-AC-T2R-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-AC-T2R-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-AC-T2R-14K-W-S7.25",
    },
    SOAC: {
      // Solstice Accented
      RB: "CONFIG-1CT-ND-RB-AC-SOAC-14K-W-S7",
      RA: "CONFIG-1CT-ND-RA-AC-SOAC-14K-W-S7",
      PE: "CONFIG-1CT-ND-PE-AC-SOAC-14K-W-S7",
      PR: "CONFIG-1CT-ND-PR-AC-SOAC-14K-W-S7",
      OV: "CONFIG-1CT-ND-OV-AC-SOAC-14K-W-S7",
      MQ: "CONFIG-1CT-ND-MQ-AC-SOAC-14K-W-S7",
      HT: "CONFIG-1CT-ND-HT-AC-SOAC-14K-W-S7",
      EM: "CONFIG-1CT-ND-EM-AC-SOAC-14K-W-S7",
      CR: "CONFIG-1CT-ND-CR-AC-SOAC-14K-W-S7",
      AS: "CONFIG-1CT-ND-AS-AC-SOAC-14K-W-S7",
    },
  },
  HL: {
    // Halo category
    NP: {
      //   // Naples
      //   RB: "CONFIG-1CT-ND-RB-HL-NP-14K-W-S7.25",
    },
    PG: {
      //   // Prague
      //   RB: "CONFIG-1CT-ND-RB-HL-PG-14K-W-S7.25",
      //   PE: "CONFIG-1CT-ND-PE-HL-PG-14K-W-S7.25",
      //   OV: "CONFIG-1CT-ND-OV-HL-PG-14K-W-S7.25",
    },
    PS: {
      // Palm Springs
      RB: "CONFIG-1CT-ND-RB-HL-PS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-HL-PS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-HL-PS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-HL-PS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HL-PS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-HL-PS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-HL-PS-14K-W-S7.25",
    },
    BRC: {
      // Barcelona
      MQ: "CONFIG-1CT-ND-MQ-HL-BRC-14K-W-S7.25",
      RB: "CONFIG-1CT-ND-RB-HL-BRC-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HL-BRC-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-HL-BRC-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-HL-BRC-14K-W-S7.25",
    },
    NV: {
      // Novara
      PE: "CONFIG-1CT-ND-PE-HL-NV-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HL-NV-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-HL-NV-14K-W-S7.25",
    },
    BGA: {
      // Baguette Accented
      RB: "CONFIG-1CT-ND-RB-HL-BGA-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-HL-BGA-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PE-HL-BGA-14K-W-S7.25",
      PC: "CONFIG-1CT-ND-PR-HL-BGA-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HL-BGA-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-HL-BGA-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-HL-BGA-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-HL-BGA-14K-W-S7.25",
    },
  },
  HDH: {
    // Hidden Halo category
    SO: {
      // Solstice
      RB: "CONFIG-1CT-ND-RB-HDH-SO-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-HDH-SO-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-HDH-SO-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-HDH-SO-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HDH-SO-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-HDH-SO-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-HDH-SO-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-HDH-SO-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-HDH-SO-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-HDH-SO-14K-W-S7.25",
    },
    HH: {
      // Hidden Halo
      RB: "CONFIG-1CT-ND-RB-HDH-HH-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-HDH-HH-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-HDH-HH-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-HDH-HH-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-HDH-HH-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-HDH-HH-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-HDH-HH-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-HDH-HH-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-HDH-HH-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-HDH-HH-14K-W-S7.25",
    },
  },
  THR: {
    // Three Stone category
    CK: {
      // Celtic Knot
      RA: "CONFIG-1CT-ND-RA-THR-CK-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-THR-CK-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-THR-CK-14K-W-S7.25",
      RB: "CONFIG-1CT-ND-RB-THR-CK-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-THR-CK-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-THR-CK-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-THR-CK-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-THR-CK-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-THR-CK-14K-W-S7.25",
    },
    ALL: {
      // Allure
      AS: "CONFIG-1.25CT-ND-AS-THR-ALL-14K-W-S7.25",
    },
    OA: {
      // Open Arms
      RB: "CONFIG-1CT-ND-RB-THR-OA-14K-W-S7.25",
    },
    SG: {
      // Sage
      RB: "CONFIG-1CT-ND-RB-THR-SG-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-THR-SG-14K-W-S7.25",
    },
    PSSA: {
      // Pear Side Stone Accented
      RB: "CONFIG-1CT-ND-RB-THR-PSSA-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-THR-PSSA-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-THR-PSSA-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-THR-PSSA-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-THR-PSSA-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-THR-PSSA-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-THR-PSSA-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-THR-PSSA-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-THR-PSSA-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-THR-PSSA-14K-W-S7.25",
    },
    PSS: {
      // Pear Side Stone
      RB: "CONFIG-1CT-ND-RB-THR-PSS-14K-W-S7.25",
      RA: "CONFIG-1CT-ND-RA-THR-PSS-14K-W-S7.25",
      PE: "CONFIG-1CT-ND-PE-THR-PSS-14K-W-S7.25",
      PR: "CONFIG-1CT-ND-PR-THR-PSS-14K-W-S7.25",
      OV: "CONFIG-1CT-ND-OV-THR-PSS-14K-W-S7.25",
      MQ: "CONFIG-1CT-ND-MQ-THR-PSS-14K-W-S7.25",
      HT: "CONFIG-1CT-ND-HT-THR-PSS-14K-W-S7.25",
      EM: "CONFIG-1CT-ND-EM-THR-PSS-14K-W-S7.25",
      CR: "CONFIG-1CT-ND-CR-THR-PSS-14K-W-S7.25",
      AS: "CONFIG-1CT-ND-AS-THR-PSS-14K-W-S7.25",
    },
    // MGLR: {
    //   // Morning Glory
    //   RB: "CONFIG-1CT-ND-RB-THR-MGLR-14K-W-S7.25",
    //   PR: "CONFIG-1CT-ND-PR-THR-MGLR-14K-W-S7.25",
    //   CR: "CONFIG-1CT-ND-CR-THR-MGLR-14K-W-S7.25",
    //   AS: "CONFIG-1CT-ND-AS-THR-MGLR-14K-W-S7.25",
    // },
  },
};

export const defaultConfigForStyleShape = {
  SLTR: {
    // Solitaire
    AS: "CONFIG-1CT-ND-AS-SLTR-SO-14K-W-S7.25",
    // CR: "CONFIG-1CT-ND-CR-SLTR-BL-14K-W-S7.25",
    CR: "CONFIG-1CT-ND-CR-SLTR-SO-14K-W-S7.25",
    EM: "CONFIG-1CT-ND-EM-SLTR-SO-14K-W-S7.25",
    HT: "CONFIG-1CT-ND-HT-SLTR-SO-14K-W-S7.25",
    // MQ: "CONFIG-1CT-ND-MQ-SLTR-BL-14K-W-S7.25",
    // OV: "CONFIG-1CT-ND-OV-SLTR-BL-14K-W-S7.25",
    // PE: "CONFIG-1CT-ND-PE-SLTR-BL-14K-W-S7.25",
    MQ: "CONFIG-1CT-ND-MQ-SLTR-SO-14K-W-S7.25",
    OV: "CONFIG-1CT-ND-OV-SLTR-SO-14K-W-S7.25",
    PE: "CONFIG-1CT-ND-PE-SLTR-SO-14K-W-S7.25",
    PR: "CONFIG-1CT-ND-PR-SLTR-SO-14K-W-S7.25",
    RA: "CONFIG-1CT-ND-RA-SLTR-SO-14K-W-S7.25",
    // RB: "CONFIG-1CT-ND-RB-SLTR-BL-14K-W-S7.25",
    RB: "CONFIG-1CT-ND-RB-SLTR-SO-14K-W-S7.25",
    TL: "CONFIG-1CT-ND-TL-SLTR-EW-14K-W-S7.25",
  },
  AC: {
    // Accented
    AS: "CONFIG-1CT-ND-AS-AC-CS-14K-W-S7.25",
    CR: "CONFIG-1CT-ND-CR-AC-HV-14K-W-S7.25",
    EM: "CONFIG-1CT-ND-EM-AC-HV-14K-W-S7.25",
    HT: "CONFIG-1CT-ND-HT-AC-HV-14K-W-S7.25",
    MQ: "CONFIG-1CT-ND-MQ-AC-HV-14K-W-S7.25",
    OV: "CONFIG-1CT-ND-OV-AC-HV-14K-W-S7.25",
    PE: "CONFIG-1CT-ND-PE-AC-HV-14K-W-S7.25",
    PR: "CONFIG-1CT-ND-PR-AC-HV-14K-W-S7.25",
    RA: "CONFIG-1CT-ND-RA-AC-HV-14K-W-S7.25",
    RB: "CONFIG-1CT-ND-RB-AC-HV-14K-W-S7.25",
    TL: "CONFIG-1.50CT-TL-AC-EW-14K-W-S7.25",
  },
  HL: {
    // Halo
    AS: "CONFIG-1CT-ND-AS-HL-BRC-14K-W-S7.25",
    CR: "CONFIG-1CT-ND-CR-HL-PS-14K-W-S7.25",
    EM: "CONFIG-1CT-ND-EM-HL-PS-14K-W-S7.25",
    HT: "CONFIG-1CT-ND-HT-HDH-SO-14K-W-S7.25",
    MQ: "CONFIG-1CT-ND-MQ-HL-BRC-14K-W-S7.25",
    // OV: "CONFIG-1CT-ND-OV-HL-PG-14K-W-S7.25",
    // PE: "CONFIG-1CT-ND-PE-HL-PG-14K-W-S7.25",
    OV: "CONFIG-1CT-ND-OV-HL-PS-14K-W-S7.25",
    PE: "CONFIG-1CT-ND-PE-HL-PS-14K-W-S7.25",
    PR: "CONFIG-1CT-ND-PR-HL-PS-14K-W-S7.25",
    RA: "CONFIG-1CT-ND-RA-HL-PS-14K-W-S7.25",
    // RB: "CONFIG-1CT-ND-RB-HL-NP-14K-W-S7.25",
    RB: "CONFIG-1CT-ND-RB-HL-PS-14K-W-S7.25",
    TL: "CONFIG-1CT-ND-TL-SLTR-EW-14K-W-S7.25",
  },
  HDH: {
    // Hidden Halo
    AS: "CONFIG-1CT-ND-AS-HDH-SO-14K-W-S7.25",
    CR: "CONFIG-1CT-ND-CR-HDH-SO-14K-W-S7.25",
    EM: "CONFIG-1CT-ND-EM-HDH-SO-14K-W-S7.25",
    HT: "CONFIG-1CT-ND-HT-HDH-SO-14K-W-S7.25",
    MQ: "CONFIG-1CT-ND-MQ-HDH-SO-14K-W-S7.25",
    OV: "CONFIG-1CT-ND-OV-HDH-HH-14K-W-S7.25",
    PE: "CONFIG-1CT-ND-PE-HDH-HH-14K-W-S7.25",
    PR: "CONFIG-1CT-ND-PR-HDH-HH-14K-W-S7.25",
    RA: "CONFIG-1CT-ND-RA-HDH-HH-14K-W-S7.25",
    RB: "CONFIG-1CT-ND-RB-HDH-HH-14K-W-S7.25",
    TL: "CONFIG-1CT-ND-TL-SLTR-EW-14K-W-S7.25",
  },
  THR: {
    // Three Stone
    AS: "CONFIG-1.25CT-ND-AS-THR-ALL-14K-W-S7.25",
    CR: "CONFIG-1CT-ND-CR-THR-CK-14K-W-S7.25",
    EM: "CONFIG-1CT-ND-EM-THR-CK-14K-W-S7.25",
    HT: "CONFIG-1CT-ND-HT-THR-CK-14K-W-S7.25",
    MQ: "CONFIG-1CT-ND-MQ-THR-CK-14K-W-S7.25",
    OV: "CONFIG-1CT-ND-OV-THR-CK-14K-W-S7.25",
    PE: "CONFIG-1CT-ND-PE-THR-CK-14K-W-S7.25",
    PR: "CONFIG-1CT-ND-PR-THR-CK-14K-W-S7.25",
    RA: "CONFIG-1CT-ND-RA-THR-CK-14K-W-S7.25",
    RB: "CONFIG-1CT-ND-RB-THR-CK-14K-W-S7.25",
    TL: "CONFIG-1CT-ND-TL-SLTR-EW-14K-W-S7.25",
  },
};
